/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     leap-form-guidance p{margin-bottom:9px;font-size:16px!important;color:#26273b!important}form[_ngcontent-%COMP%]{display:flex;margin-top:20px}nz-select[_ngcontent-%COMP%]{width:200px}.margin-right-30[_ngcontent-%COMP%]{margin-right:30px}"];
export { styles as styles };
